export const loader = {
    namespaced: true,
    state: {count: 0},
    actions: {
        start({commit}) {
            commit('inc')
        },
        end({commit}) {
            commit('dec')
        }
    },
    mutations: {
        inc(state) {
            state.count++
        },
        dec(state) {
            state.count--
        }
    }
}
